import { render, staticRenderFns } from "./LoaderCube.vue?vue&type=template&id=19acecaf&scoped=true&"
import script from "./LoaderCube.vue?vue&type=script&lang=js&"
export * from "./LoaderCube.vue?vue&type=script&lang=js&"
import style0 from "./LoaderCube.vue?vue&type=style&index=0&id=19acecaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19acecaf",
  null
  
)

export default component.exports